module.exports = __webpack_public_path__ + "static/junyoungkim-65ce3cba3a97e669e33d4316b8dc50b3.jpeg";